import React from "react";
import CategoryContainer from "../../components/Category/CategoryContainer";
import Pagination from "../../components/Layout/Pagination";
import UseAllCategory from "../../CustomHooks/Category/UseAllCategory";
import NavBar from "../../components/Layout/NavBar";
import Footer from "../../components/Layout/Footer";
import UseViewSearchProducts from "../../CustomHooks/Products/UseViewSearchProducts";

const AllCategoryPage = () => {
  const [searchValue, handleChangeSearchValue, allCategories, loading, pageCount, onPress] = UseAllCategory()
  const [NumberOfPages, AllLoading, SearchLoading, items, onPressPage, searchProductsFunc, onChangeSearchInput, searchInputValue] = UseViewSearchProducts()

  return (
    <div className="d-flex justify-content-between flex-column">
      <NavBar onChangeSearchInput={onChangeSearchInput} searchInputValue={searchInputValue} />
      <div className="mh-100-exact">
        <CategoryContainer AllCategories={allCategories} loading={loading} />
        {pageCount > 1 ? (<Pagination pageCount={pageCount} onPress={onPress} className="mt-4" />) : null}
      </div>

      <Footer />
    </div>
  );
};

export default AllCategoryPage;
